export interface IOperatorInfoModel {
  operatorID: number;
  operatorName: string;
  partialDeliveryAccess: boolean;
  companyID: number;
}

export class OperatorInfoModel implements IOperatorInfoModel {
  constructor(operatorID: number, operatorName: string, partialDeliveryAccess: boolean = false, companyID: number = 1) {
    this.operatorID = operatorID;
    this.operatorName = operatorName;
    this.partialDeliveryAccess = partialDeliveryAccess;
    this.companyID = companyID;
  }

  companyID = -1;
  operatorID = -1;
  operatorName = "okänd.";
  partialDeliveryAccess = false;
}
